
import {
  computed,
  defineComponent, reactive,
  watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useGradeBase } from '@/core/composables/GradeBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import SelecionarControleProducao from '../Cadastros/PCP/SelecionarControleProducao.vue';
import { IOrdemProducaoControle } from '@/models/Entidades/PCP/IOrdemProducao';
import { IControleProducao } from '@/models/Entidades/Cadastros/PCP/IControleProducao';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { ETipoControleProducao } from '@/models/Enumeradores/Cadastros/PCP/ETipoControleProcucao';

export default defineComponent({
  name: 'OrdemProducaoControle',
  props: {
    visivel: {
      type: Boolean,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    controles: {
      type: Array as () => IOrdemProducaoControle[],
      required: true,
    },
    codigoOrdemProducao: {
      type: Number,
      required: true,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
    atualizarControles: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icone,
    SelecionarControleProducao,
    CampoNumerico,
  },
  emits: ['salvar', 'update:visivel', 'update:controle', 'update:atualizarControle'],
  setup(props, { emit }) {
    const {
      apresentarMensagemAlerta,
    } = useTelaBase();
    const {
      gradeBase,
    } = useGradeBase();

    const state = reactive({
      editavel: true,
      codigoProdutoSelecionado: -1,
      descricaoSelecionado: '',
      codigo: 0,
      valor: 0,
      tipoControle: ETipoControleProducao,
      controle: {} as IControleProducao,
    });

    const computedControle = computed({
      get: () => props.controles,
      set: (val: IOrdemProducaoControle[]) => {
        emit('update:controle', val);
      },
    });

    const computedAtualizarControles = computed({
      get: () => props.atualizarControles,
      set: (val: boolean) => {
        emit('update:atualizarControle', val);
      },
    });
    function objetoInicial() {
      state.editavel = true;
      state.codigoProdutoSelecionado = -1;
      state.codigo = 0;
      state.valor = 0;
      state.descricaoSelecionado = '';
      state.controle.tipoControle = ETipoControleProducao.Outros;
    }

    function limparCampos() {
      state.codigoProdutoSelecionado = -1;
      state.codigo = 0;
      state.descricaoSelecionado = '';
      state.valor = 0;
      state.controle.tipoControle = ETipoControleProducao.Outros;
    }

    function validaCampos() {
      if (!UtilitarioGeral.validaCodigo(state.codigo)) {
        apresentarMensagemAlerta('Por favor selecione um controle!');
        return false;
      }
      if (!UtilitarioGeral.valorValido(state.valor)) {
        apresentarMensagemAlerta('Por favor informe um valor!');
        return false;
      }
      if (state.codigoProdutoSelecionado === -1 && computedControle.value.some((p) => p.codigoControleProducao === state.codigo)) {
        apresentarMensagemAlerta('O controle já foi adicionado!');
        return false;
      }
      if (state.codigoProdutoSelecionado === -1 && computedControle.value.some((p) => p.tipoControle === state.controle.tipoControle && state.controle.tipoControle > 1)) {
        apresentarMensagemAlerta('Já existe um controle desse tipo informado!');
        return false;
      }
      return true;
    }

    async function adicionar() {
      if (!validaCampos()) { return; }
      if (state.codigoProdutoSelecionado !== -1) {
        computedControle.value[state.codigoProdutoSelecionado].codigoControleProducao = state.codigo;
        computedControle.value[state.codigoProdutoSelecionado].valor = state.valor;
        computedControle.value[state.codigoProdutoSelecionado].descricao = state.descricaoSelecionado;
        computedControle.value[state.codigoProdutoSelecionado].tipoControle = state.controle.tipoControle;
        limparCampos();
      } else {
        const controle: IOrdemProducaoControle = {} as IOrdemProducaoControle;
        controle.codigo = 0;
        controle.codigoOrdemProducao = props.codigoOrdemProducao;
        controle.codigoControleProducao = state.codigo;
        controle.valor = state.valor;
        controle.descricao = state.descricaoSelecionado;
        controle.tipoControle = state.controle.tipoControle;
        computedControle.value.push(controle);
        limparCampos();
      }
    }

    function excluir(index: number) {
      computedControle.value.splice(index, 1);
      state.codigoProdutoSelecionado = -1;
    }

    function editar(index: number) {
      state.codigoProdutoSelecionado = index;
    }

    watch(() => state.codigoProdutoSelecionado, (newValue) => {
      if (newValue !== -1) {
        const item = computedControle.value[newValue];
        state.codigo = item.codigoControleProducao;
        state.valor = item.valor;
        state.descricaoSelecionado = item.descricao;
        state.controle.tipoControle = item.tipoControle;
      } else {
        limparCampos();
      }
    });

    function selectAll(event:any) {
      event.target.select(); // Seleciona todo o texto do input
    }

    watch(() => computedControle.value, () => {
      computedAtualizarControles.value = true;
    },
    { deep: true });

    return {
      props,
      state,
      objetoInicial,
      EPermissaoDados,
      gradeBase,
      ECustomRenderRow,
      editar,
      excluir,
      adicionar,
      computedControle,
      UtilitarioGeral,
      selectAll,
    };
  },
});
